




import { Component, Vue } from 'vue-property-decorator'
import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue'
import AddEdit from './AddEdit.vue'
import { getResponseToMTHForNewPort } from '@/utils/helpers'
import constants from '@/utils/constants'

class ReviewSettingItem {
  id: string = ''
  outletCode: string = ''
  formThreshold: number = 0
  title: string = ''
  question: string = ''
  status: number = 0
  googleReviewLink: string = ''
}

@Component({
  components: {
    editor: AddEdit
  }
})
class ReviewSettings extends RemoteDataTable<ReviewSettingItem> {
  public pageTitle: string = 'Review Settings'
  public newButtonText: string = 'New Review'

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({
      key: 'outletCode',
      label: 'Outlet Code',
      filter:
        this.$store.state.currentUser.Type === 'Admin' ? 'input' : 'select',
      options: [
        {
          text: 'All',
          value: this.$store.state.currentUser.OutletCodes.join(',')
        }
      ].concat(
        this.$store.state.currentUser.OutletCodes.map(item => ({
          text: item,
          value: item
        }))
      )
    }),
    new RemoteDataField({ key: 'formThreshold', label: 'Form Threshold' }),
    new RemoteDataField({ key: 'title', label: 'Title' }),
    new RemoteDataField({ key: 'question', label: 'Question' }),
    new RemoteDataField({ key: 'status', label: 'Status' }),
    new RemoteDataField({
      key: 'googleReviewLink',
      label: 'Google Review Link'
    })
  ]
  public uid: any = localStorage.getItem('UID')
  // to get page data
  get items(): ReviewSettingItem[] {
    return this.$store.getters.GetAllReview
  }

  get paging(): ReviewSettingItem[] {
    return this.$store.getters.PagingReview
  }

  get sorting(): ReviewSettingItem[] {
    return this.$store.getters.SortingReview
  }

  get filtering(): ReviewSettingItem[] {
    return this.$store.getters.FilteringReview
  }

  formatterForPercent(value) {
    return value ? `${value}%` : '-'
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingReview', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc,
      uid: this.uid
    })
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringReview', {
      isResetFilter: isResetFilter,
      uid: this.uid
    })
  }

  checkUserAndGetData() {
    this.$store.dispatch('GetAllReview', this.uid)
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.review.pagingReview.page = 1
    }
    this.checkUserAndGetData()
  }

  setPerPage(page) {
    this.$store.state.review.pagingReview.size = page
    this.checkUserAndGetData()
  }

  mounted() {
    if (this.$store.state.currentUser.Type !== 'Admin') {
      this.$store.commit('SET_FILTERING_REVIEW', {
        ...this.filtering,
        outletCode: this.$store.state.currentUser.OutletCodes.join(',')
      })
      this.$store.dispatch('GetAllReview')
    }
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteReview', item.id)
          .then(response => {
            getResponseToMTHForNewPort(
              response,
              this.$swal,
              constants.RECORD_IS_DELETED
            )
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error,
              constants.STATUS_ERROR
            )
          })
      }
    })
  }
}

@Component({
  components: {
    ReviewSettings
  }
})
export default class List extends Vue {}
